<template>
  <div>
    <span class="ticketType_0"
      v-for="e in ticketTypeList"
      :key="e.id"
      :title="JSON.stringify(e)">{{e.name}}</span>
  </div>
</template>

<script>
export default {
  name: "TicketTypeParent",

  props : ['id'],

  data() {
    return {
      ticketTypeList : []
    }
  },

  mounted() {
    sdk.TicketTypeApi().findParentById({
      id : this.id
    }).then(res => {
      if ( !res ) {
        return;
      }

      this.ticketTypeList = [res];
    })
  }
}
</script>

<style>
  .ticketType_0 {
    margin: 2px 2px;
    padding: 0 5px;
    background: #efefef;
    border-radius:5px;
    display: inline-block;
  }
</style>


// WEBPACK FOOTER //
// src/components/setting/TicketTypeParent.vue